import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.25 10.5L11.9542 13.9136C11.8996 13.969 11.8263 14 11.75 14C11.6737 14 11.6004 13.969 11.5458 13.9136L8.25 10.5",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 5.5L4.04583 2.08636C4.10035 2.031 4.17366 2 4.25 2C4.32634 2 4.39965 2.031 4.45417 2.08636L7.75 5.5",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 2V13.5",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.75 2.5V14",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgSort;
